import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export const HiringBanner = () => (
  <Link
    to="/earn-with-us"
    data-testid="hiring-banner"
    className="group relative z-10 block bg-[#FF4500] text-[#1C1C1C]"
  >
    <div className="mx-auto max-w-7xl px-5 sm:px-8 py-3 flex items-center justify-center gap-2 text-center text-sm font-semibold">
      <span>
        Now accepting movers in Dallas–Fort Worth and Memphis. Pick your own
        jobs and get paid same day.{" "}
        <span className="underline underline-offset-2">Earn With Us</span>
      </span>
      <ArrowRight className="h-4 w-4 shrink-0 transition-transform group-hover:translate-x-1" />
    </div>
  </Link>
);
